import React from 'react'
import { Box } from '@mui/material'
import logo from 'assets/images/logo.png'

/**
 * logo.png need to be place at /assets/images/logo.png
 * Change H to corp image
 * W of the image must be 440px to fit the box
 */

const LogoBrand: React.FC = () => {
  return (
    <Box
      sx={{
        pb: 5,
        pt: 5,
        mb: 0,
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        '& img': {
          maxWidth: '70%',
        },
      }}
    >
      <img className="w-[440px]" src={logo} width="100%" />
    </Box>
  )
}

export default LogoBrand
